import React, { useEffect } from "react";
import HeroLoginSignup from "../components/heroManagementDashboard/signUpLogIn/HeroLoginSignup"; // Adjust the path based on your project structure
import { useNavigate } from "react-router-dom";

const HeroLoginRegisterPage = () => {
  const navigate = useNavigate();

  const phrases = [
    "AI driven business processes with Hero.",
    "Hero AI auditor keeping you compliant.",
    "Maximize productivity with Hero's intuitive management tools.",
    "Release AI agents to supercharge productivity.",
    "Use our intelegence system to gain data insights.",
    "Automate client communication with Hero AI agents.",
  ];

  const handleRegisterClick = () => {
    navigate("/heroRegisterOnlineUser"); // Adjust the path to your registration page
  };

  const handleLoginClick = () => {
    navigate("/heroLogin"); // Adjust the path to your login page
  };

  useEffect(() => {
    // Scroll to the top of the page when the component mounts
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="hero-login-register-page">
      <HeroLoginSignup
        phrases={phrases}
        onRegisterClick={handleRegisterClick}
        onLoginClick={handleLoginClick}
      />
    </div>
  );
};

export default HeroLoginRegisterPage;
